import Vuex from 'vuex'
import Vue from 'vue'

import API from '../../services/api';
import dataService from '../../services/data-service';

const api = new API();

Vue.use(Vuex)


const stateHelper = {
  updateArray(res, stateArray, key) {

    res = Array.isArray(res) ? res : [res]; // Turn into array, so we can handle it same way
    const resIds = {};
    const added = [];

    res.forEach(item => {
      resIds[item[key]] = item;
    });

    // If already added, update
    for(let i=stateArray.length-1; i>=0; i--) {
      if(resIds[stateArray[i][key]]) {
        stateArray.splice(i, 1, resIds[stateArray[i][key]]);
        added.push(stateArray[i][key]);
      }
    }

    // Add new ones
    if(added.length !== res.length) {
      res.forEach(item => {
        if(added.indexOf(item[key]) === -1) {
          stateArray.push(item);
        }
      });
    }
  },
  removeFromArray(id, stateArray, key) {
    for(let i=stateArray.length-1; i>=0; i--) {
      if(stateArray[i][key] === id) {
        stateArray.splice(i, 1);
        return;
      }
    }
  }
}

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    language: '',
    user: {
      info: null,
      company: null,
      role: null
    },
    subheader: {
      title: '',
      description: '',
      searchEnabled: false,
      searchText: ''
    },
    customerMachines: [],
    customerMachineDetails: [],
    companies: [],
    users: [], // company id as key for an array of user objects
    complaints: [],
    warrantyRegistrations: [],
    warrantedSerialNumbers: [],
    loggedIn: false,
    needsLoggingIn: true,
    localization: null,
    preloading: true,
    countries: [],
    subheaderFound: false,
    subheaderSubtitle: '',
    subheaderTitle: '',
    subheaderDescription: '',
    notificationsQueue: [],
    notificationsMax: 6
  },
  mutations: {
    setLanguage(state, res) {
      state.language = res;
    },
    setCurrentUser(state, res) {
      state.user.info = res;
      state.user.role = res.role;
    },
    setCurrentUserCompany(state, res) {
      state.user.company = res;
    },
    setCurrentMachineOwner(state, res) {
      state.machine.customerNumber = res.customerNumber;
      state.machine.companyName = res.companyName;
    },
    setLoginStatus(state, res) {
      state.loggedIn = res;
    },
    setNeedsLogginIn(state, res) {
      state.needsLoggingIn = res;
    },
    setLocalization(state, res) {
      state.localization = res;
    },
    setPreloadingStatus(state, res) {
      state.preloading = res;
    },
    setCompanies(state, res) {
      stateHelper.updateArray(res, state.companies, 'id');
    },
    setCompany(state, res) {
      stateHelper.updateArray(res, state.companies, 'id');
    },
    setCountries(state, res) {
      state.countries = res
    },
    setSubheaderFound(state, res) {
      state.subheaderFound = res;
    },
    setSubheader(state, res) {
      state.subheader.subtitle = res.subtitle;
      state.subheader.title = res.title;
      state.subheader.description = res.description;
      state.subheader.searchEnabled = res.searchEnabled;
    },
    setSubheaderSearchText(state, res) {
      state.subheader.searchText = res;
    },
    setCustomerMachines(state, res) {
      stateHelper.updateArray(res, state.customerMachines, 'serialNumber');
    },
    setCustomerMachineDetails(state, res) {
      stateHelper.updateArray(res, state.customerMachineDetails, 'serialNumber');
    },
    addCompany(state, res) {
      state.companies.push(res);
    },
    updateCompany(state, res) {
      stateHelper.updateArray(res, state.companies, 'id');
    },
    deleteCompany(state, res) {
      stateHelper.removeFromArray(res, state.companies, 'id');
    },
    setComplaints(state, res) {
      stateHelper.updateArray(res, state.complaints, 'uuid');
    },
    setWarrantedSerialNumbers(state, res) {
      state.warrantedSerialNumbers = res;
    },
    addComplaint(state, res) {
      stateHelper.updateArray(res, state.complaints, 'uuid');
    },
    setWarrantyRegistrations(state, res) {
      stateHelper.updateArray(res, state.warrantyRegistrations, 'uuid');
    },
    addWarrantyRegistration(state, res) {
      stateHelper.updateArray(res, state.warrantyRegistrations, 'uuid');
    },
    setUsers(state, res) {
      stateHelper.updateArray(res, state.users, 'id');
    },
    addUser(state, res) {
      stateHelper.updateArray(res, state.users, 'id');
    },
    updateUser(state, res) {
      stateHelper.updateArray(res, state.users, 'id');
    },
    deleteUser(state, res) {
      stateHelper.removeFromArray(res, state.users, 'id');
    },
    addNotification(state, messages) {
      state.notificationsQueue.push(messages.join(', '))

      if (state.notificationsQueue.length > state.notificationsMax) {
        state.notificationsQueue.shift()
      }
    },
    updateAdditionalInformation(state, message) {
      state.additionalInformation = message
    }
  },
  actions: {
    getCountries(context) {
      // Only fetch countries once
      if(context.state.countries.length) {
        return;
      }

      return api.getCountries()
      .then(res => {
        if(res.result.countries) {
          context.commit('setCountries', res.result.countries);
        }
      });
    },
    getCurrentUser({ commit }) {
      return api.getCurrentUser()
      .then((res) => {
        // If we can get proper answer, we're logged in
        if(res.code === 200) {
          commit('setLoginStatus', true);
        }

        commit('setCurrentUser', res.result.user);
        commit('setCurrentUserCompany', res.result.company);
      });
    },
    getLocalization({commit}) {
      return api.getLocalization()
      .then(res => {
        if(res.result.localization) {
          commit('setLocalization', res.result.localization);
        }
      });
    },
    getComplaints({commit}, options) {
      if(!options) {
        return api.getComplaints({
          includeChildCompanies: true
        })
        .then(res => {
          if(res.result.complaints) {
            commit('setComplaints', res.result.complaints);
          }
          if(res.result.warrantedSerialNumbers) {
            commit('setWarrantedSerialNumbers', res.result.warrantedSerialNumbers)
          }
        });
      }

      return api.getComplaints(options)
      .then(res => {
        if(res.result.complaints) {
          commit('setComplaints', res.result.complaints);
        }
      });
    },
    getComplaint({commit}, complaintId) {
      return api.getComplaint(complaintId)
      .then(res => {
        if(res.result.complaint) {
          commit('setComplaints', res.result.complaint);
        }
      });
    },
    getWarrantyRegistrations({commit}, options) {
      if(!options) {
        return api.getWarrantyRegistrations({includeChildCompanies: true})
        .then(res => {
          if(res.result.warrantyRegistrations) {
            commit('setWarrantyRegistrations', res.result.warrantyRegistrations);
          }
        });
      }

      return api.getWarrantyRegistrations(options)
      .then(res => {
        if(res.result.warrantyRegistrations) {
          commit('setWarrantyRegistrations', res.result.warrantyRegistrations);
        }
      });
    },
    getWarrantyRegistration({commit}, warrantyRegistrationId) {
      return api.getWarrantyRegistration(warrantyRegistrationId)
      .then(res => {
        if(res.result.warrantyRegistration) {
          commit('setWarrantyRegistrations', res.result.warrantyRegistration);
        }
      });
    },
    getCustomerMachines({commit}, companyId) {
      return api.getCustomerMachines({
        company: companyId,
        includeChildCompanies: true
      })
      .then(res => {
        if(res.result.customerMachines) {
          commit('setCustomerMachines', res.result.customerMachines);
        }
      });
    },
    getCustomerMachine({commit}, serialNumber) {
      return api.getCustomerMachine(serialNumber)
      .then(res => {
        if(res.result.customerMachine) {
          commit('setCustomerMachines', res.result.customerMachine);
        }
      });
    },
    getCustomerMachineDetails({commit}, serialNumber) {
      return api.getCustomerMachineDetails(serialNumber)
      .then(res => {
        if(res.result.customerMachineDetails) {
          commit('setCustomerMachineDetails', res.result.customerMachineDetails);
        }
      });
    },
    getChildCompanies(context) {
      return api.getCompanies({
        childrenOf: context.state.user.info.company,
        includeUsersOfRoles: ['retailer-admin']
      })
      .then(res => {
        if(res.result.companies) {
          res.result.companies.forEach(company => {
            company.users.forEach(user => {
              if(!company.contacts) {
                company.contacts = [];
              }
            });
          });
          context.commit('setCompanies', res.result.companies);
        }
      });
    },
    getCompany({commit}, companyId) {
      return api.getCompany(companyId)
      .then(res => {
        if(res.result.company) {
          commit('setCompany', res.result.company);
        }
      });
    },
    getCompanyUsers(context, companyId) {
      return api.getUsers({
        company: companyId
      })
      .then(res => {
        if(res.result.users) {
          context.commit('setUsers', res.result.users);
        }
      });
    },
    deleteCompany(context, companyId) {
      return api.deleteCompany(companyId)
      .then(res => {
        if(res.result.company) {
          context.commit('deleteCompany', res.result.company);
        }
      });
    },
    getUser({commit}, userId) {
      return api.getUser(userId)
      .then(res => {
        if(res.result.user) {
          commit('addUser', res.result.user);
        }
      });
    }
  },
  getters: {
    countrySelectOptions: state => {
      return state.countries.map(item => {
        return {
          value: item.countryCode,
          text: item.name
        };
      });
    },
    childCompanies: state => {

      var children = state.user.info.role === 'site-admin'
                  ? state.companies.filter(Boolean) //clear null values
                  : state.companies.filter(company => { return company.parent === state.user.company.id });

      return children;
    },
    childCompaniesOptions: state => {
      var filteredChildren = state.user.info.role === 'site-admin'
                  ? state.companies.filter(Boolean) //clear null values
                  : state.companies.filter(company => { return company.parent === state.user.company.id });

      return filteredChildren.map (item => {
        return {
          value: item.id,
          text: item.name
        };
      });

    }
  }
});

dataService.setVuexStore(store);

export default store
